import { createAsyncThunk } from '@reduxjs/toolkit';

import { set } from '../../utils/request';
import { METHOD_POST } from '../../constants/api';

const getRegistrationErrorMessage = (error) => {
  const validationErrors = error?.errors || error?.data?.errors || {};
  const validationMessages = Object.values(validationErrors)
    .flat()
    .filter(Boolean);

  if (validationMessages.length) {
    return validationMessages.join(' ');
  }

  return error?.message || error?.data?.message || 'error on registration';
};

const postRegistration = createAsyncThunk('auth/register',
  async (formData = {}, { rejectWithValue }) => {
    try {
      const { user } = await set(METHOD_POST, '/register', formData);
      return user;
    } catch (error) {
      return rejectWithValue(getRegistrationErrorMessage(error));
    }
  });

export default postRegistration;
